'use client';

import React from 'react';
import { useParams } from 'next/navigation';
import { CategoryTypeId } from '@diritto/common/content/constants';
import {
  CategoryNavigationMenu,
  CategoryNavigationMenuPath,
  CategoryNavMenuToCategoryMap,
} from '@diritto/common/navigation/constant';
import { ExploreNavigationMenu, ExploreNavigationMenuPath } from '@diritto/common/navigation/explore';
import { getKeyByValue } from '@diritto/common/utils/array';
import { extractEnumValue } from '@diritto/common/utils/enum';
import { ExplorePage } from 'app/(mainNavigation)/explore/[exploreMenu]/[categoryNavMenu]/ExplorePage';

export default function Page() {
  const params = useParams();

  const categoryNavMenu =
    getKeyByValue(CategoryNavigationMenuPath, params?.categoryNavMenu ?? '') ?? CategoryNavigationMenu.All;
  const categoryType = CategoryNavMenuToCategoryMap[categoryNavMenu as CategoryNavigationMenu];
  const categoryId = categoryType ? CategoryTypeId[categoryType] : undefined;

  const exploreMenu = extractEnumValue(
    ExploreNavigationMenu,
    getKeyByValue(ExploreNavigationMenuPath, params?.exploreMenu ?? '') ?? '',
    ExploreNavigationMenu.All,
  );

  return (
    <>
      <title>탐색 | 디리토 - 자유연재 웹소설의 시작</title>
      <ExplorePage categoryId={categoryId} exploreMenu={exploreMenu} categoryNavMenu={categoryNavMenu} />
    </>
  );
}
